import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiService {

  constructor(public http: HttpClient) { }

  post(endpoint: string, body?: any, requestOpts?: any): Observable<Object> {
    return this.http.post(
      environment.apiUrl + '/' + endpoint,
      body,
      requestOpts
    );
  }
  
  postLambda(endpoint: string, body?: any, requestOpts?: any): Observable<Object> {
    return this.http.post(
      environment.lambdaApiUrl + '/' + endpoint,
      body,
      requestOpts
    );
  }

}
